// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3QP6f","box":"WorkspacesBox_box__3toPT","node":"WorkspacesBox_node__2tBab"};